function SnoringFAQ() {
  return <main className="page main-content">Inside SnoringFAQ</main>;
}

export default SnoringFAQ;
